module.exports = __webpack_public_path__ + "img/box-open.b7ea7dda.svg";